import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { AdvertQueryResponse } from '../../../models/advert.model';
import { FilterSearchService } from '../../../services/filter-search.service';
import { AdvertService } from '../../../services/advert.service';
import { EAdvertSortOrder } from '../../../datatypes/misc';
import { SearchFormSharedService } from '../../search/searchForm/searchForm.shared.service';
import { AdvertQuery } from '../../../models/advertQuery.model';
import { AdvertQueryHelper } from '../../../helpers/AdvertQueryHelper';

@Component({
    selector: 'filter-search',
    templateUrl: './filter-search.component.html',
    styleUrls: ['./filter-search.component.css']
})

export class FilterSearchComponent implements OnInit {

    public readonly EAdvertSortOrderPublishDate = EAdvertSortOrder.PublishDate;
    public readonly EAdvertSortOrderClosingDate = EAdvertSortOrder.ClosingDate;
    public readonly EAdvertSortOrderDistance = EAdvertSortOrder.GeoDistance;
    public readonly EAdvertSortOrderRelevance = EAdvertSortOrder.Score;

    public showDistanceTab: boolean;
    public showRelevanceTab: boolean;

    private SortMenuPositionPublishDate = 0;
    private SortMenuPositionRelevance = 1;
    private SortMenuPositionClosingDateA = 2;
    private SortMenuPositionClosingDateB = 1;
    private SortMenuPositionDistanceA = 3;
    private SortMenuPositionDistanceB = 2;


    @Input()
    public searchResponse: AdvertQueryResponse = new AdvertQueryResponse();

    @Input()
    public activeFilterTab: number;

    @Output()
    public isSorted = new EventEmitter<any>();

    @Output()
    public emitSearchResult = new EventEmitter<AdvertQueryResponse>();


    constructor(
        private advertService: AdvertService,
        private filterSearch: FilterSearchService,
        public searchFormSharedService: SearchFormSharedService,
    ) { }

    ngOnInit(): void {
        this.searchFormSharedService.getDistanceTabView().subscribe(val => this.showDistanceTab = val);
        this.searchFormSharedService.getRelevanceTabView().subscribe(val => this.showRelevanceTab = val);
        this.searchFormSharedService.getRelevanceTabView().subscribe(res => this.resetFilter(res));
    }

    sortByPublishDate() {
        if (this.IsSingleResultsPage()) {
            this.searchResponse.Results = this.filterSearch.sortResultByPublishDate(this.searchResponse.Results);
        } else {
            this.ResetPagingAndSetSortOrder(this.searchResponse.SearchQuery, EAdvertSortOrder.PublishDate);
            this.doSearch(this.searchResponse.SearchQuery);
        }

        // tslint:disable-next-line: deprecation
        this.isSorted.emit(event);
        this.searchFormSharedService.setSortOrder(EAdvertSortOrder.PublishDate);
    }

    sortByClosingDate() {

        if (this.IsSingleResultsPage()) {
            this.searchResponse.Results = this.filterSearch.sortResultByClosingDate(this.searchResponse.Results);
        } else {
            this.ResetPagingAndSetSortOrder(this.searchResponse.SearchQuery, EAdvertSortOrder.ClosingDate);
            this.doSearch(this.searchResponse.SearchQuery);
        }
        // tslint:disable-next-line: deprecation
        this.isSorted.emit(event);
        this.searchFormSharedService.setSortOrder(EAdvertSortOrder.ClosingDate);
    }


    sortByRelevance() {
        if (this.IsSingleResultsPage()) {
            this.searchResponse.Results = this.filterSearch.sortResultByRelevance(this.searchResponse.Results);
        } else {
            this.ResetPagingAndSetSortOrder(this.searchResponse.SearchQuery, EAdvertSortOrder.Score);
            this.doSearch(this.searchResponse.SearchQuery);
        }
        // tslint:disable-next-line: deprecation
        this.isSorted.emit(event);
        this.searchFormSharedService.setSortOrder(EAdvertSortOrder.Score);
    }

    sortByDistance() {
        if (this.IsSingleResultsPage()) {
            this.searchResponse.Results = this.filterSearch.sortResultByDistance(this.searchResponse.Results);
        } else {
            this.ResetPagingAndSetSortOrder(this.searchResponse.SearchQuery, EAdvertSortOrder.GeoDistance);
            this.doSearch(this.searchResponse.SearchQuery);
        }

        // tslint:disable-next-line: deprecation
        this.isSorted.emit(event);
        this.searchFormSharedService.setSortOrder(EAdvertSortOrder.GeoDistance);
    }

    resetFilter(event: boolean) {
        if (event) {
            this.activeFilterTab = this.searchResponse.AdvertSortOrder;
        }
    }

    private ResetPagingAndSetSortOrder(advertQuery: AdvertQuery, advertSortOrder: EAdvertSortOrder) {
        advertQuery.AdvertSortOrder = advertSortOrder;
        advertQuery.PagingDictionary = AdvertQueryHelper.getNewPagingDictionary();
    }


    private IsSingleResultsPage(): boolean {
        const single = (this.searchResponse.Results && this.searchResponse.SearchQuery.PagingDictionary.MaxNumResultPages === 1);
        return single;
    }

    private doSearch(advertQuery: AdvertQuery) {
        this.advertService.getAdvertSearch(advertQuery).subscribe(r => this.emitSearchResult.emit(r));
    }

    private isSingleResultPage(advertQueryResponse: AdvertQueryResponse): boolean {
        const first = advertQueryResponse.SearchQuery.PagingDictionary.isFirstPage;
        const last = advertQueryResponse.NoMorePages;
        return first && last;
    }
}
